exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mobile-cover-with-overlay__slidable-overlay__3oGOi{position:absolute;top:0;left:0;right:0;bottom:0;z-index:130}", ""]);

// exports
exports.locals = {
	"slidable-overlay": "mobile-cover-with-overlay__slidable-overlay__3oGOi",
	"slidableOverlay": "mobile-cover-with-overlay__slidable-overlay__3oGOi"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/components/cover-with-overlay/mobile-cover-with-overlay.styl
// module id = 2909
// module chunks = 1